import styled from 'styled-components';
import { body1, spacing } from 'ui/theme';
import {
  SegmentedControlField,
  SegmentedControlValueType,
} from '../../../../../../lib/iterable-hook-form/FormField/SegmentedControlField';
import { Caption } from './OptimizeSection.styles';
import { PRIORITY_LEVEL_OPTIONS } from './constants';

const EditablePriorityLevelContainer = styled.div`
  ${body1};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  word-break: break-word;
  white-space: break-spaces;
  gap: ${spacing.half};
`;

export const EditablePriorityLevel = () => (
  <EditablePriorityLevelContainer>
    <SegmentedControlField
      name="priorityLevel"
      options={PRIORITY_LEVEL_OPTIONS}
      type={SegmentedControlValueType.Number}
    />
    <Caption>
      Sets message display order (for apps using Iterable&apos;s mobile SDKS). Consider giving
      transactional campaigns a higher priority than marketing campaigns.
    </Caption>
  </EditablePriorityLevelContainer>
);
